import { Grid } from '@mui/material';
import React from 'react';
import { GlobalFilterTypeHandle } from '../../../../context/types';
import { UndoRedo } from '../../unredo/UndoRedo';
import { FilterSection } from '../types';
import { FilterPills } from './FilterPills';
import { Reset } from './Reset';
import { FilterBarOptions, FilterTypes } from './types';
import { defaultOptions } from './utils-display';

export interface FilterBarProps<T extends FilterTypes> {
  filterHandle: GlobalFilterTypeHandle<T>;
  filterSections: FilterSection[];
  options?: FilterBarOptions;
}

export const FilterBar = <T extends FilterTypes>(props: FilterBarProps<T>) => {
  const { filterHandle, filterSections, options = defaultOptions } = props;
  const [state] = filterHandle;
  return (
    <Grid item container>
      <Grid
        item
        container
        xs
        justifyContent={options.justifyContent}
        alignItems="flex-start"
        alignContent="flex-start"
      >
        <UndoRedo itemsHandle={filterHandle} />
        {state.items.length > 0 && <Reset<T> filterHandle={filterHandle} />}
        <FilterPills<T>
          filtersHandle={filterHandle}
          filterSections={filterSections}
          options={options}
        />
      </Grid>
    </Grid>
  );
};
